const utils = require('../utils');


function assignEvent() {
    $('.btn-clickCollect-search').on('click', () => {
        const url = $('.clickcollect-in-store').data('url');
        const requestData = {
            searchKey: $('#state').val(),
            showAvailable: true,
        };
        const newUrl = utils.appendToUrl(url, requestData);

        $.ajax({
            url: newUrl,
            method: 'POST',
            success(response) {
                $('#clickCollect-in-store-store-result').empty().html(response.renderedTemplate);
                $(document).find("[id^='input-']").on('click', () => {
                    $('.select-store-clickCollect').removeAttr('disabled');
                });

                $('.select-store-clickCollect, .select-store-input').on('click', (e) => {
                    e.preventDefault();
                    const selectedStore = $(':checked', '.results-card .card-body');
                    const storeDetailsHtml = selectedStore
                        .parent()
                        .find('.store-details')
                        .html();

                    const data = {
                        storeID: selectedStore.val(),
                        searchRadius: '',
                        searchPostalCode: '',
                        storeDetailsHtml,
                        event: e,
                    };

                    const clickCollectStoreResults = $('#clickCollect-in-store-store-result');

                    const newLabel = $(data.storeDetailsHtml);
                    const content = $('<div class="selectedStore store-details"></div>')
                        .append(newLabel)
                        .append(`<input type="hidden" id="clickCollectStore" name="storeId" value="${data.storeID}" />`);

                    clickCollectStoreResults.empty().append(content);
                    const changeStoreButton = $('.store-selected-hidden-wrapper .change-store').clone();
                    clickCollectStoreResults.append(changeStoreButton);
                    if (clickCollectStoreResults.is(':hidden')) {
                        clickCollectStoreResults.show();
                    }

                    const clickCollectInStore = $('.clickcollect-in-store');
                    clickCollectInStore.find('.first').hide();
                    clickCollectInStore.find('.last').hide();
                });
            },
        });
    });
}

/**
 * Hide store finder and restore address form
 * @param {Object} shippingForm - DOM element with current form
 * @param {Object} data - data containing customer and order objects
 */
function hideClickCollectFinder(shippingForm) {
    shippingForm.find('.clickcollect-in-store').addClass('d-none');
    shippingForm.find('.gift-message-block').removeClass('d-none');
    shippingForm.find('input[name="storeId"]').remove();
}

/**
 * Show store locator when appropriate shipping method is selected
 * @param {Object} shippingForm - DOM element that contains current shipping form
 */
function showClickCollectFinder(shippingForm) {
    const $clickStore = shippingForm.find('.clickcollect-in-store');

    $clickStore.removeClass('d-none');

    $('#clickCollect-in-store-store-result').html('');

    $('.clickCollectSelected').addClass('d-none');

    if (!$clickStore.find('.first').is('visible')) {
        $clickStore.find('.first').show();
    }
    if (!$clickStore.find('.last').is('visible')) {
        $clickStore.find('.last').show();
    }

    $('.btn-clickCollect-search').unbind();
    assignEvent();
}

module.exports = {
    showClickCollectFinder,
    hideClickCollectFinder,
    assignEvent,
};
